import React from "react";

export default ({items, keyFunc, textFunc, onRemoveItem}) => {

    return <div className="flex space-x-2 items-center justify-center mt-4">

        {items.map(item => {

            return <div
                key={keyFunc(item)}
                className="inline-flex items-center justify-between space-x-1 px-2 py-0.5 rounded-md border border-gray-200 rounded-md bg-gray-50"
            >
                <svg onClick={() => onRemoveItem(item)}
                     className="cursor-pointer h-4 w-4 text-green-900"
                     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
                <div className="select-none">
                    {textFunc(item)}
                </div>
            </div>

        })}
    </div>
}